// extracted by mini-css-extract-plugin
export default {"header":"header_header__TRXcv","navigation":"header_navigation__YAl3t","navLink":"header_navLink__BUHPb","logo":"header_logo__I8ERj"};